export const DISCONNECTED = "Disconnected";
export const NOT_STARTED = "Meeting not started";
export const PREPARING = "Preparing room";
export const READY = "Meeting ready";
export const JOINING = "Joining";
export const CONNECTED = "Connected";
export const LEAVING = "Leaving";
export const LEFT = "You have left the Meeting";
export const ENDED = "Meeting ended";
